import React, { useState } from 'react';

import './header-desk.scss';

import logoImg from '../../../../static/img/SeznamBrowser-Logo.svg';
import headerBg from '../../../../static/img/header-bg.svg';
import headerBgBuildings from '../../../../static/img/header-bg-buildings.svg';
import krastyAlphabet from '../../../../static/img/krasty-alphabet.svg';

const Header = (props) => {
  const changeBrowserMagnification = (scale) => {
    window.postMessage({ command: 'sbrowser-zoomLevel', value: scale });
  };

  const showLoginPage = () => {
    console.log('Sbrowser-login sent');
    window.postMessage({ command: 'sbrowser-login' });
  };

  const importHistory = () => {
    console.log('Sbrowser-import sent');
    window.postMessage({ command: 'sbrowser-import' });
  };

  return (
    <header style={{ backgroundImage: `url(${headerBg})`, backgroundSize: 'cover' }}>
      <div className="content-wrapper">
        <img className="bg" src={headerBgBuildings} />
        <div className="content content-wrapper">
          <div className="heading">
            <img src={logoImg} alt="logo" />
            <div className="text">
              <h1>Vítejte v prohlížeči od Seznamu</h1>
              <p>Ještě, než začneme…</p>
            </div>
          </div>
          <div className="settings-list">
            <div className="settings-box">
              <h3>Váš prohlížeč, váš Seznam</h3>
              <div className="line"></div>
              <p className="custom">Přihlaste se a získejte rychlý přístup k Emailu i propojení s mobilní aplikací. Vše, co si uložíte, máte hned po ruce.</p>
              {props.loggedAccount
                ? <p className="login">Přihlášen jako: {props.loggedAccount.accountName}</p>
                : <button className="custom-button red red-shadow" onClick={showLoginPage}>Přihlásit se</button>
              }
            </div>
            <div className="settings-box">
              <h3>Buďte tu jako doma</h3>
              <div className="line"></div>
              <p className="custom">Používali jste jiný prohlížeč? Přeneste si oblíbené stránky a historii prohlížení. Ať vám tu nic nechybí.</p>
              <button className="custom-button white" onClick={importHistory}>Přenést oblíbené a historii</button>
            </div>
            <div className="settings-box">
              <h3>Vidíte na vše dobře?</h3>
              <div className="line"></div>
              <p className="custom">Nastavte si velikost písma i obrázků tak, abyste při toulkách internetem na vše dobře viděli.</p>
              <ul className="font-size-settings">
                <li className={`dot ${props.zoomLevel === 'normal' ? 'active' : null}`}
                  onClick={() => {
                    changeBrowserMagnification('normal');
                  }}>
                  <span>
                    Normální
                  </span>
                </li>
                <li className={`dot ${props.zoomLevel === 'big' ? 'active' : null}`}
                  onClick={() => {
                    changeBrowserMagnification('big');
                  }}>
                  <span>
                    Velká
                  </span>
                </li>
                <li className={`dot ${props.zoomLevel === 'giant' ? 'active' : null}`}
                  onClick={() => {
                    changeBrowserMagnification('giant');
                  }}>
                  <span>
                    Obří
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div className="separator">
            <h2 className="heading-separator">Co umí?</h2>
            <img src={krastyAlphabet} />
          </div>
        </div>
        <div className="button-list">
          <a href="#section1"><button type="button" className="custom-button">Rychle do Emailu i na Seznam</button></a>
          <a href="#section2"><button type="button" className="custom-button">Snadné ukládání</button></a>
          <a href="#section3"><button type="button" className="custom-button">Nový boční panel</button></a>
          <a href="#section4"><button type="button" className="custom-button">Překladač</button></a>
          <a href="#section5"><button type="button" className="custom-button">Bezpečné prohlížení</button></a>
        </div>
      </div>
    </header>
  );
};

class HeaderDesk extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { zoomLevel: 'normal', loggedAccount: null };
  }

  componentDidMount() {
    window.addEventListener('message', (evt) => {
      const { data } = evt;
      const { command, response } = data;
      if (typeof response === 'undefined') return;
      switch (command) {
        case 'sbrowser-zoomLevel':
          this.setState({ zoomLevel: response });
          break;
        case 'sbrowser-loggedAccount':
          this.setState({ loggedAccount: response });
          break;
        case 'sbrowser-login':
          this.setState({ loggedAccount: response });
          break;
        // no default
      }
    });
    window.postMessage({ command: 'sbrowser-zoomLevel', value: '' });
    window.postMessage({ command: 'sbrowser-loggedAccount', value: '' });
  }

  render() {
    return (
      <Header {...this.state} />
    );
  }
}

export default HeaderDesk;
